module.exports = __webpack_public_path__ + "img/faq-sm.2bc2f848.svg";